var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96979 3.05469L8.62746 2.55342C8.62257 2.54626 8.61536 2.53588 8.60655 2.52322C8.58014 2.48522 8.53943 2.42666 8.50427 2.37269L8.5036 2.37166C7.52441 0.860583 5.88012 0.290246 4.57099 0.567884L8.96979 3.05469ZM8.96979 3.05469L9.39621 2.62269M8.96979 3.05469L9.39621 2.62269M9.39621 2.62269C9.55028 2.4666 9.70517 2.29695 9.85032 2.13797M9.39621 2.62269L9.85032 2.13797M16.9104 3.30696L16.9103 3.30686C16.0065 0.886414 13.0381 -0.44638 10.7003 1.31061L16.9104 3.30696ZM16.9104 3.30696C17.5145 4.9236 17.1601 6.46423 16.3061 7.99131L16.3061 7.99133M16.9104 3.30696L16.3061 7.99133M16.3061 7.99133C14.9771 10.3678 13.0601 12.2635 10.9113 13.9759M16.3061 7.99133L10.9113 13.9759M9.85032 2.13797C9.92703 2.05395 10.001 1.97291 10.0707 1.89842M9.85032 2.13797L10.0707 1.89842M10.0707 1.89842C10.284 1.67056 10.4847 1.47273 10.7002 1.31069L10.0707 1.89842ZM10.9113 13.9759C9.77505 14.8811 8.31485 14.8435 7.16032 13.8992L10.9113 13.9759ZM7.16023 13.8991C5.1904 12.2871 3.40887 10.5333 2.10641 8.38254L7.16023 13.8991ZM2.10632 8.38239C1.29615 7.04338 0.826773 5.67922 1.05985 4.15513L2.10632 8.38239ZM1.05988 4.15491C1.33322 2.37383 2.61521 0.983932 4.57092 0.567898L1.05988 4.15491Z",
    stroke: "#04D6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/LikeIcon.226287d1f62fba7029a96638f751be34.svg";
export { ForwardRef as ReactComponent };